import cn from 'classnames';
import React from 'react';
import { LimitedTimeOfferBadge } from 'src/components/long-term-content/components/limited-time-offer-badge';
import { Text } from 'src/components/text/Text';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { SUBVENTION_COUNTRY } from 'src/constants/subvention-country';
import { useAppContext } from 'src/context/store/app-provider';

import styles from './InstallmentItem.css';

export interface Props {
  title: string;
  subtitle: string;
  paymentsInfo: string;
  list?: boolean;
  isLimitedTimeOffer?: boolean;
  isGreenSubtitle?: boolean;
  additionalContent?: React.ReactNode;
  noInterest?: string | null;
}

export const InstallmentItem = ({
  title,
  subtitle,
  paymentsInfo,
  list,
  isLimitedTimeOffer,
  isGreenSubtitle,
  additionalContent,
  noInterest,
}: Props) => {
  const { currency } = useAppContext();
  const country = COUNTRY_NAME_BY_CURRENCY_MAP[currency];

  return (
    <div
      className={cn(styles.InstallmentItem, {
        [styles.InstallmentItem_list]: list,
      })}
      data-test="payment-plan"
    >
      <div
        className={cn(styles.InstallmentItem__Content, {
          [styles.InstallmentItem__Content_list]: list,
          [styles.InstallmentItem__Content_withAdditionalContent]:
            list && additionalContent,
        })}
      >
        <div className={styles.InstallmentItem__Header}>
          <Text as="p" variant="body1Tight" data-test="payment-plan-title">
            {title}
          </Text>
          <Text as="span" variant="body1Tight" data-test="payment-plan-price">
            {paymentsInfo}
          </Text>
        </div>
        <div className={styles.InstallmentItem__Footer}>
          <Text
            as="p"
            variant="body2Tight"
            className={cn(styles.InstallmentItem__Description, {
              [styles.InstallmentItem__Description_free]: isGreenSubtitle,
            })}
            data-test="payment-plan-subtitle"
          >
            {noInterest && (
              <span
                className={cn(styles.InstallmentItem__AdditionalDescription, {
                  [styles.InstallmentItem__AdditionalDescription_free]:
                    isLimitedTimeOffer,
                })}
              >
                {noInterest}.
              </span>
            )}
            {subtitle}
          </Text>
          {SUBVENTION_COUNTRY.includes(country) && isLimitedTimeOffer && (
            <LimitedTimeOfferBadge />
          )}
        </div>
      </div>
      {additionalContent && (
        <div
          className={cn(styles.InstallmentItem__AdditionalContent, {
            [styles.InstallmentItem__AdditionalContent_list]: list,
          })}
        >
          {additionalContent}
        </div>
      )}
    </div>
  );
};
